<template>
  <div class="portfolio">
    <div class="header">
      <span class="page-title">پورتفولیو</span>
      <div class="switch-comp" :style="{maxWidth:'400px'}">
        <button dir="ltr" class="switch-comp-button" :class="{'active-opt':baseCoin==='USDT' }"
                @click="baseCoin='USDT'">USDT
          <span class="division-line"/>
          تتر
        </button>
        <button dir="ltr" class="switch-comp-button" :class="{'active-opt':baseCoin==='BTC' }" @click="baseCoin='BTC'">
          BTC
          <span class="division-line"/>
          ییتکوین
        </button>
        <button dir="ltr" class="switch-comp-button" :class="{'active-opt':baseCoin==='TMN' }" @click="baseCoin='TMN'">
          TMN
          <span class="division-line"/>
          تومان
        </button>
        <button dir="ltr" class="switch-comp-button" :class="{'active-opt':baseCoin==='GOLD' }" @click="baseCoin='GOLD'">
          طلا
        </button>
      </div>
    </div>

    <div class="top-section">

      <div class="depsoit-profit">

        <DonutChartSection  :basecoin = 'baseCoin'/>

<!--        <div class="changes-section">-->

<!--          <div class="change-row">-->
<!--            <div class="change-label">سود شما</div>-->
<!--            <div class="change-values">-->
<!--              <div class="change-percent positive" dir="ltr"><span>+</span>{{ profitPercent }}%</div>-->
<!--              <div class="change-value">{{ harmValue.toLocaleString() }}</div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="change-row">-->
<!--            <div class="change-label">زیان شما</div>-->
<!--            <div class="change-values">-->
<!--              <div class="change-percent negative" dir="ltr"><span>-</span>{{ harmPercent }}%</div>-->
<!--              <div class="change-value">{{ harmValue.toLocaleString() }}</div>-->
<!--            </div>-->
<!--          </div>-->

<!--        </div>-->

      </div>
      <div class="carousel-chart">
        <CoinsCarousel :basecoin = 'baseCoin' :wallets="wallets" :key="baseCoin"/>
        <TotalDepositChart/>
      </div>


    </div>

    <TradesTable/>
    <div class="history-link" @click="$router.push('/panel/history')">
      مشاهده همه تاریخچه
      <img src="../../../../assets/icon/left-arrow.svg"/>
    </div>
  </div>
</template>

<script>
import TotalDepositChart from "./TotalDepositChart";
import DonutChartSection from "./DonutChartSection";
import CoinsCarousel from "./CoinsCarousel";
import TradesTable from './TradesTable';

export default {
    name: "portofilo",
  components: {DonutChartSection, CoinsCarousel, TotalDepositChart,TradesTable},
  data() {
    return {
      baseCoin: 'TMN',
      harmValue:322355,
      profitValue:809885,
      harmPercent:3,
      profitPercent:5,
      wallets: [],
    }
  },
  methods: {
    async getWallets() {
      this.state.loading = true
      // const coinsList="ETHEREUM,BITCOIN_CASH,TRON,RIPPLE,TETHER,TOMAN,BITCOIN"
      this.loading = true
      const [res,] = await this.$http.get('/wallets/customer-addresses?walletType=P2P')

      if (res) {
        let entireRes = Object.entries(res)
        const sortCoins = this.$walletSortCoins
        entireRes.sort((a, b) => sortCoins.indexOf(a[0]) - sortCoins.indexOf(b[0]))
        this.toman = entireRes[0]
        entireRes = entireRes
        // console.log(entireRes)

        this.wallets = entireRes
        entireRes = entireRes.filter(item => item[1].credit != 0 && item[0] !== 'TOMAN')
        this.wallets = entireRes
        // this.tomancash = res["TOMAN"].credit
        // this.toman = res['TOMAN']

// console.log(this.wallets)

      }
      this.loading = false

    },
  },
  mounted() {
    this.getWallets()
  },
}
</script>

<style lang="scss" scoped>
.history-link{
  display: flex;
  align-items: center;
  column-gap: 8px;
  color: #1199FA;
  cursor: pointer;
  font-size: clamp(14px,1.5vw,16px);
  text-align: left;
  justify-content: flex-end;
}
.page-title{
  font-size: clamp(18px,2vw,24px);
  font-weight: bold;
  color: white;
}
.changes-section{
  display: flex;
  row-gap: 28px;
  flex-direction: column;
  padding: 25px 16px;
  background: linear-gradient(180deg, #091222 0%, #0A1425 100%);
  box-shadow: 0px 4px 24px -1px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
}
.change-row{
  display: flex;
  justify-content: space-between;
}

.change-value{
  font-size: clamp(14px,1.5vw,16px);
  color: #FFFFFF;
  font-weight: bold;
}
.change-values{
  display: flex;
  column-gap: 8px;
}
.change-label{
  font-size: clamp(14px,1.5vw,16px);
  color: #FFFFFF;
  font-weight: bold;
}




.top-section {
  display: flex;
  row-gap: 24px;
  column-gap: 24px;
}

.depsoit-profit {
  flex: 1;
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  column-gap: 24px;
}

.carousel-chart {
  flex: 2.5;
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  column-gap: 24px;
}

.active-opt {
  background: rgba(215, 200, 200, 0.12) !important;
  color: rgba(17, 153, 250, 1) !important;
}

.switch-comp {
  display: flex;
  align-items: center;
  column-gap: 7px;
  flex-wrap: wrap;
  flex-grow: 1;
}
.positive{
  color: #04B3A2;
}
.negative{
  color:#D94F68;
}
.division-line {
  height: 14px;
  width: 1px;
  background: #D7C8C8;
}

.switch-comp-button {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 4px;
  background: transparent;
  border-radius: 4px;
  border: 0.5px solid rgba(215, 200, 200, 0.35);
  cursor: pointer;
  white-space: nowrap;
  font-size: clamp(10px, 1.1vw, 12px);
  height: 32px;
  max-width: 92px;
  color: #D7C8C8;
  flex-grow: 1;
}

.portfolio {
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  gap: 25px;
}

.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

@media(max-width: 1300px){
  .top-section{
    flex-wrap: wrap;

  }
}

@media(max-width: 400px){
  .symbol-title{
    display: none;
  }
}

</style>